export const safeJSONParse = <T = any>(value: unknown, fallback: T): T => {
  if (!value) {
    return fallback;
  }

  if (typeof value !== 'string') {
    return value as T;
  }

  try {
    return JSON.parse(value) as T;
  } catch {
    return fallback;
  }
};
